

document.addEventListener('DOMContentLoaded', function () {
    var c, currentScrollTop = 0,
    navbar = document.querySelector('.site-header');
    var logo = document.querySelector('.site-header__logo');

    window.addEventListener('scroll', function () {
        var a = window.scrollY;
        var b = navbar.offsetHeight;

        currentScrollTop = a;
        navbar.classList.remove('site-header--collapse');

        if (c < currentScrollTop && a > b) {
            navbar.classList.add('site-header--scroll-up');
        } else if (c > currentScrollTop && !(a <= b)) {
            navbar.classList.remove('site-header--scroll-up');
            navbar.classList.add('site-header--collapse');
        }
        c = currentScrollTop;
    });

    document.querySelector('.menu__toggle').addEventListener('click', function () {
       // navbar.classList.toggle('site-header--collapse');
    });
});

// Make links with # prevent default behavior
document.addEventListener('DOMContentLoaded', function () {
    var links = document.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('click', function (e) {
            e.preventDefault();
        });
    }
});